import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { SET_CHART_TYPE } from 'modules/Statistics/types'

export default (chart) => {
  const dispatch = useDispatch()

  return useCallback(
    () =>
      dispatch({
        type: SET_CHART_TYPE,
        payload: { type: chart.chartType === 'Line' ? 'Bar' : 'Line' },
      }),
    [chart],
  )
}
